import React from 'react';
type SectionHeadingProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  title,
  subtitle,
  tone = 'light'
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-65" data-mp="3f25cf5v46ml7">
      <h2 className={`text-balance font-display text-[28px] font-extrabold leading-[1.15] tracking-tight sm:text-4xl lg:text-[44px] ${tone === 'dark' ? 'text-white' : 'text-navy'}`} data-id="element-66" data-mp="3f3gdgxx6dg8m">
        {title}
      </h2>
      {subtitle && <p className={`mx-auto mt-4 max-w-2xl text-pretty text-base leading-relaxed sm:text-lg ${tone === 'dark' ? 'text-white/75' : 'text-ink-muted'}`} data-id="element-67" data-mp="giwzd7x5me5v">
          {subtitle}
        </p>}
    </div>;
}